import _ from 'lodash';
import { itemTypeConfigMap } from '../verticals';
import { ITEM_TYPES } from '@wix/seo-types';
import { WIX_STORES } from '@wix/app-definition-ids';
const shouldScanPage = (itemType, pageIntentId, isExperimentEnabled) => {
  var _config$excludedPageI;
  if (!itemType) {
    return false;
  }
  if (itemType === ITEM_TYPES.STATIC_PAGE_V2 && !pageIntentId) {
    return true;
  }
  const config = itemTypeConfigMap[itemType];
  const isDisabled = config.enabledBy && !isExperimentEnabled(config.enabledBy);
  const isTemplate = config.templatePageIntentId === pageIntentId;
  const isExcluded = (_config$excludedPageI = config.excludedPageIntentIds) == null ? void 0 : _config$excludedPageI.includes(pageIntentId ?? '');
  return !isTemplate && !isExcluded && !isDisabled;
};
const getItemTypeConfigsByAppDefinitionId = appDefinitionId => {
  // quick fix for the mismatch between the app definition id and the item type
  const isWixStores = appDefinitionId === WIX_STORES;
  if (isWixStores) {
    return [itemTypeConfigMap[ITEM_TYPES.STORES_PRODUCT]];
  }
  if (!appDefinitionId) {
    return [itemTypeConfigMap[ITEM_TYPES.STATIC_PAGE_V2]];
  }
  return _.groupBy(Object.values(itemTypeConfigMap), _ref => {
    let {
      appDefId
    } = _ref;
    return appDefId;
  })[appDefinitionId] ?? [];
};
const isSupportedItemTypeTemplatePage = (itemType, pageIntentId, isExperimentEnabled) => {
  if (!itemType || itemType === ITEM_TYPES.STATIC_PAGE_V2) {
    return false;
  }
  const config = itemTypeConfigMap[itemType];
  const isDisabled = config.enabledBy && !isExperimentEnabled(config.enabledBy);
  const isTemplate = config.templatePageIntentId === pageIntentId;
  return !isDisabled && isTemplate;
};
export const staticPageUtils = {
  getItemTypeConfigsByAppDefinitionId,
  shouldScanPage,
  isSupportedItemTypeTemplatePage
};
//# sourceMappingURL=static-page-utils.js.map